var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 80,
    viewBox: "0 0 86 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8902 59.4577C24.4913 60.9999 23.0979 62.1372 21.4365 62.1372C19.4656 62.1372 17.8638 60.5354 17.8638 58.5645C17.8638 56.5935 19.4656 54.9917 21.4365 54.9917C23.0979 54.9917 24.4972 56.129 24.8902 57.6713H42.8493C42.3789 46.2504 32.9766 37.1279 21.4365 37.1279C9.59881 37.1279 0 46.7267 0 58.5645C0 70.4022 9.59881 80.001 21.4365 80.001C32.9766 80.001 42.3789 70.8845 42.8493 59.4577H24.8902Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3086 37.1279C60.7239 37.1279 57.3417 38.0152 54.3763 39.5693L63.3559 55.1227C63.6596 55.0394 63.9811 54.9917 64.3086 54.9917C66.2796 54.9917 67.8814 56.5935 67.8814 58.5645C67.8814 60.5354 66.2796 62.1372 64.3086 62.1372C62.3376 62.1372 60.7359 60.5354 60.7359 58.5645C60.7359 57.5641 61.1467 56.665 61.8077 56.0159L52.8282 40.4685C46.8438 44.2734 42.8721 50.9545 42.8721 58.5645C42.8721 70.4022 52.4709 80.001 64.3086 80.001C76.1464 80.001 85.7452 70.4022 85.7452 58.5645C85.7452 46.7267 76.1464 37.1279 64.3086 37.1279Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8731 0C31.0353 0 21.4365 9.59881 21.4365 21.4365C21.4365 29.0525 25.4082 35.7335 31.3926 39.5385L40.3721 23.9851C39.7112 23.3361 39.3003 22.4369 39.3003 21.4365C39.3003 19.4656 40.9021 17.8638 42.8731 17.8638C44.844 17.8638 46.4458 19.4656 46.4458 21.4365C46.4458 23.4075 44.844 25.0093 42.8731 25.0093C42.5396 25.0093 42.224 24.9617 41.9203 24.8783L32.9408 40.4317C35.9062 41.9859 39.2884 42.8731 42.8731 42.8731C54.7108 42.8731 64.3096 33.2743 64.3096 21.4365C64.3096 9.59881 54.7108 0 42.8731 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.42c1f1d6b8d2314fae81eb1e3233a046.svg";
export { ForwardRef as ReactComponent };